import React from "react";

import { Navigate, useParams } from "react-router-dom";

import { getSolutionBySlug } from "../data/solutions";

import { ServiceDetailPage } from "../components/ServiceDetailPage";

import { WebsiteDevelopmentPage } from "./WebsiteDevelopmentPage";

import { MobileAppDevelopmentPage } from "./MobileAppDevelopmentPage";

import { DigitalMarketingPage } from "./DigitalMarketingPage";

import { PostEditingPage } from "./PostEditingPage";

import { VideoEditingPage } from "./VideoEditingPage";



const customSolutionPages: Record<string, React.ReactNode> = {

    "website-development": <WebsiteDevelopmentPage />,

    "mobile-app-development": <MobileAppDevelopmentPage />,

    "digital-marketing": <DigitalMarketingPage />,

    "post-editing": <PostEditingPage />,

    "video-editing": <VideoEditingPage />,

};



export const SolutionPage = () => {

    const { slug } = useParams();

    const item = slug ? getSolutionBySlug(slug) : undefined;



    if (!item) {

        return <Navigate to="/" replace />;

    }



    const customPage = slug ? customSolutionPages[slug] : undefined;

    if (customPage) {

        return customPage;

    }



    return <ServiceDetailPage item={item} category="solutions" categoryLabel="Solutions" />;

};


